import { Empty, Form, Radio, Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import { cloneDeep, isArray } from 'lodash-es'
import noData from '@/assets/noData.png'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
export default function ModifyStandard(props) {
  const { formList, skuList, currentSku, setCurrentSku } = props
  const [list, setList] = useState<any>([])
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)
  const [showButtons, setShowButtons] = useState({})
  const elementRefs = useRef<Record<string, HTMLDivElement | null>>({})
  useEffect(() => {
    console.log(formList, 'formList')

    setList(formList)
  }, [])
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }
  // 初始化
  useEffect(() => {
    console.log(formList, 'formList')
    if (isArray(formList) && formList?.length > 0) {
      if (formList.length === 1) {
        // 处理只有一种的情况
        let el = formList[0]
        el.options.map((option: any) => {
          let canbechoose = skuList?.find(sku => sku.argMap[el.argCode].valueId === option.valueId)
          if (canbechoose) {
            option.disabled = false
          } else {
            option.disabled = true
          }
        })
      }
      formList.map((item, index) => {
        if (!item.argValId) {
          let canbechoose = item.options?.findIndex(el => !el.disabled)
          form.setFieldsValue({
            [item.argCode]: item.options[canbechoose]?.argValId,
          })
          item.argValId = item.options[canbechoose]?.argValId
          item.argValName = item.options[canbechoose]?.argValName
          // 默认触发一次
          argChange(item, item.options[canbechoose]?.argValId, canbechoose, 'init')
        } else {
          form.setFieldsValue({
            [item.argCode]: item.argValId,
          })
          argChange(item, item.argValId, 0, 'init')
        }
        item.options.map(option => {
          return {
            ...option,
            disabled: false,
            isExpand: false,
            isActive: false,
          }
        })
      })
    } else {
      setList([])
    }
    // setList(formList)
  }, [formList])

  // 定义一个函数，用于处理参数变化
  const argChange = (item, value, index, type) => {
    let newList: any = type === 'init' ? [...formList] : [...list]
    // console.log(item, value, index, type)
    newList.forEach((el: any) => {
      if (el.argCode === item.argCode) {
        // 当前选中的不处理禁用状态
        let optionValue = el.options?.find((option: any) => option.argValId === value)
        el.argValId = optionValue?.argValId
        el.argValName = optionValue?.argValName
        el.processDesc = optionValue?.processDesc // 添加当前选中的工艺说明
        el.options = el.options?.map((option: any) => {
          return {
            ...option,
            isActive: option.argValId === value,
          }
        })
      } else {
        // 其他非当前选用的 需要判断是否禁用
        let canBeChooseSkulist = skuList.filter((sku: any) => {
          if (sku.argMap[item.argCode].valueId === value) {
            return sku
          }
        })
        el.options.map((option: any) => {
          let canbechoose = canBeChooseSkulist.find(
            sku => sku.argMap[el.argCode].valueId === option.valueId
          )
          if (canbechoose) {
            option.disabled = false
          } else {
            option.disabled = true
          }
        })
      }
    })
    console.log(newList, 'newList')
    let selectObj = {}
    let newSkuObj: any = {}
    newList.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    console.log(newSkuObj, 'newSkuObj')

    setCurrentSku(newSkuObj)
    setList([...newList])
  }

  const expandDetail = (id: string, type = 'edit') => {
    let newList: any = type === 'init' ? [...formList] : [...list]

    newList = newList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: true,
        }
      }
      return {
        ...kit,
      }
    })
    setList([...newList])
  }

  const closeDetail = (id: string, type = 'edit') => {
    let newList: any = type === 'init' ? [...formList] : [...list]
    newList = newList?.map((kit: any) => {
      if (kit.id === id) {
        return {
          ...kit,
          isExpand: false,
        }
      }
      return {
        ...kit,
      }
    })
    setList([...newList])
  }

  useEffect(() => {
    const observers: ResizeObserver[] = []
    // 为每个元素创建监听器
    list.forEach(item => {
      const element = elementRefs.current[item.id]
      if (!element) return

      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          const height = entry.contentRect.height
          const shouldShowButton = height > 400 // 超过400px显示按钮

          setShowButtons(prev => ({
            ...prev,
            [item.id]: shouldShowButton,
          }))
        }
      })

      observer.observe(element)
      observers.push(observer)
    })
    // 清理函数
    return () => {
      observers.forEach(observer => observer.disconnect())
    }
  }, [list])
  return (
    <div className={styles.KitDetailDialogBox}>
      <div className={styles.orderDetail}>
        {list?.map((item: any, itemIndex: number) => {
          return (
            <div key={'kitItem' + itemIndex} className={styles.chooseBox}>
              <div className={styles.chooseTitle}>
                <span className={styles.titleFont}>{item?.argName}</span>
              </div>
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div
                  key={'kitItemList' + itemIndex}
                  className={styles.chooseList}
                  ref={el => (elementRefs.current[item.id] = el)}
                  style={{ maxHeight: item.isExpand ? 'fit-content' : '420px' }}
                >
                  {item?.options &&
                    item?.options?.length !== 0 &&
                    item?.options?.map((attr: any, attrIndex: number) => (
                      <div
                        key={'kitItemAttr' + attrIndex}
                        className={`${styles.item} ${attr.disabled ? styles.disabled : ''} ${attr.isActive ? styles.itemActive : ''}`}
                        onClick={() => {
                          if (attr.disabled) {
                            return
                          }
                          argChange(item, attr.argValId, itemIndex, 'edit')
                        }}
                      >
                        <div className={styles.valueNameBox}>
                          <Tooltip title={attr?.valueName} placement="topLeft">
                            <div className={styles.overflowText}> {attr?.valueName}</div>
                          </Tooltip>
                        </div>
                      </div>
                    ))}
                </div>
                {!item.isExpand && showButtons[item.id] ? (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#2D2D2E',
                    }}
                    onClick={() => {
                      expandDetail(item?.id)
                    }}
                  >
                    展开全部
                    <DownOutlined style={{ marginLeft: 4 }} />
                  </div>
                ) : null}
                {item.isExpand && showButtons[item.id] ? (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#2D2D2E',
                      marginTop: '8px',
                    }}
                    onClick={() => {
                      closeDetail(item?.id)
                    }}
                  >
                    收起全部
                    <UpOutlined style={{ marginLeft: 4 }} />
                  </div>
                ) : null}
              </div>
            </div>
          )
        })}
      </div>
      {/* {!list.length && <Empty image={noData} imageStyle={{ height: 100 }}></Empty>} */}
    </div>
  )
}
